import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

/**
 * Compact right-rail placeholder for Confluence/Figma modules not yet wired,
 * or temporarily unavailable (e.g. PostHog credentials / outage).
 */
export function DashboardComingSoonPanel({
  title,
  description,
  compact = false,
  variant = 'comingSoon',
  className,
}: {
  title: string;
  description: string;
  compact?: boolean;
  variant?: 'comingSoon' | 'unavailable';
  className?: string;
}) {
  const unavailable = variant === 'unavailable';

  return (
    <Card className={cn('border-border/40 bg-[#1a1a1c] shadow-none', className)}>
      <CardHeader className="space-y-1 p-4 pb-2">
        <div className="flex flex-wrap items-center gap-2">
          <CardTitle className="text-sm font-medium text-foreground">{title}</CardTitle>
          <Badge
            variant="outline"
            className={
              unavailable
                ? 'border-amber-500/40 bg-amber-500/10 text-[10px] font-medium uppercase tracking-wide text-amber-300'
                : 'border-sky-500/40 bg-sky-500/10 text-[10px] font-medium uppercase tracking-wide text-sky-300'
            }
          >
            {unavailable ? 'Unavailable' : 'Coming soon'}
          </Badge>
        </div>
        <p className="text-[11px] text-muted-foreground">{description}</p>
      </CardHeader>
      <CardContent className="p-4 pt-1">
        <div
          className={cn(
            'flex items-center justify-center rounded-md border border-dashed border-border/50 bg-background/20 text-[11px] text-muted-foreground',
            compact ? 'h-[72px]' : 'h-[140px]',
          )}
        >
          {unavailable ? 'Data unavailable' : 'Data pending'}
        </div>
      </CardContent>
    </Card>
  );
}
